var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10V11.8C12 12.1183 11.8736 12.4235 11.6485 12.6485C11.4235 12.8736 11.1183 13 10.8 13H4.2C3.88174 13 3.57652 12.8736 3.35147 12.6485C3.12643 12.4235 3 12.1183 3 11.8V5.2C3 4.88174 3.12643 4.57652 3.35147 4.35147C3.57652 4.12643 3.88174 4 4.2 4H6",
    stroke: "#1554FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46965 8.46965C6.17676 8.76255 6.17676 9.23742 6.46965 9.53031C6.76255 9.82321 7.23742 9.82321 7.53031 9.53031L6.46965 8.46965ZM13 2.99995L13.75 2.99994C13.75 2.58573 13.4142 2.24995 13 2.24995L13 2.99995ZM9 2.24996C8.58578 2.24997 8.25 2.58575 8.25 2.99997C8.25 3.41418 8.58579 3.74997 9 3.74996L9 2.24996ZM12.25 6.99997C12.25 7.41418 12.5858 7.74997 13 7.74997C13.4143 7.74996 13.75 7.41418 13.75 6.99996L12.25 6.99997ZM7.53031 9.53031L13.5303 3.53028L12.4697 2.46962L6.46965 8.46965L7.53031 9.53031ZM13 2.24995L9 2.24996L9 3.74996L13 3.74995L13 2.24995ZM12.25 2.99995L12.25 6.99997L13.75 6.99996L13.75 2.99994L12.25 2.99995Z",
    fill: "#1554FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.4be16d29a1bef6097cf6f241baae8c15.svg";
export { ForwardRef as ReactComponent };